import React from 'react';
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const PatternDayTraderRulePage = () => {
  return (
    <div className="bg-[#0b0d2a] text-white font-sans">
      {/* Hero Section */}
      <HeadersNonAuth />
      <br />
      <br />
        <div 
            className="relative w-full h-[300px] bg-cover bg-center flex items-center justify-center" 
            style={{ backgroundImage: "url('/headers-landing.png')" }}
        >
            <h1 className="text-white text-4xl md:text-5xl font-bold text-center">
                Pattern Day Trader Rule
            </h1>
        </div>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <p className="mb-6">
          The Pattern Day Trader (PDT) rule limits the number of day trades one can make in a margin account with less than $25,000 within a rolling five-day period. The rule was established by the Financial Industry Regulatory Authority (FINRA) in 2001 to protect novice investors from significant losses...
        </p>

        <h2 className="font-bold text-lg mb-2">Significant Points</h2>
        <ul className="list-disc list-inside mb-6 space-y-1">
          <li>The PDT rule restricts the number of day trades in a margin account with less than $25,000 within a five-day period.</li>
          <li>An account is flagged as a pattern day trader if it executes four or more day trades within any rolling five business day period.</li>
          <li>Once flagged, the account must maintain a minimum equity of $25,000, or it may face restrictions.</li>
          <li>A day trade is defined as a complete entry and exit of a stock, options, or ETF position within a single trading day.</li>
        </ul>

        <h2 className="font-bold text-lg mb-2">For Example</h2>
        <p className="mb-4">
          The Pattern Day Trader (PDT) rule is a regulation enforced by the Financial Industry Regulatory Authority (FINRA) and is applicable to traders in the United States...
        </p>

        <h3 className="font-bold">Requirements for Being Flagged as a PDT</h3>
        <ul className="list-disc list-inside mb-6 space-y-1">
          <li><strong>Account Type:</strong> The rule applies to <em>margin</em> accounts, <em>not cash accounts</em>.</li>
          <li><strong>Number of Trades:</strong> Four or more day trades in five business days.</li>
          <li><strong>Percentage of Activity:</strong> Those trades must be more than 6% of total trades in that time.</li>
        </ul>

        <h3 className="font-bold">Implications of Being Flagged as a PDT</h3>
        <ul className="list-disc list-inside mb-6 space-y-1">
          <li>Minimum Equity Requirement: Must maintain $25,000 at all times.</li>
          <li>Equity Calculation: Can include both cash and securities.</li>
          <li>Trading Limitations: No day trading until equity is restored.</li>
          <li>90-Day Freeze: Accounts can be frozen if below equity threshold.</li>
          <li>Leverage Restrictions: Margin may be limited.</li>
        </ul>

        <h3 className="font-bold">Definition of a Day Trade</h3>
        <p className="mb-4">
          A day trade is a trade where a security is bought and sold, or sold short and bought back, on the same day...
        </p>

        <h3 className="font-bold">Exceptions</h3>
        <p className="mb-4">
          Trades that are part of a hedge, or held overnight and sold the next day, usually don’t count toward the PDT rule.
        </p>
        <p className="mb-10">
          Understanding this rule is crucial to avoid restrictions that could limit your ability to trade efficiently.
        </p>
      </div>
    </div>
  );
};

export default PatternDayTraderRulePage;
